import axios from 'axios'
import store from '../../store'
// Define base url
const BASE_URL = '/api/v1/projects'

// Define projects module
const projects = {
  state: {
    data: {},
    singleData: {},
    errors: null
  },
  getters: {
    projectsCollection: state => {
      return state.data
    },
    projectsSingleData: state => {
      return state.singleData
    }
  },
  mutations: {
    getProjectsAllData (state, payload) {
      state.data = payload
    },
    getProjectsSingleData (state, payload) {
      state.singleData = payload
    },
    setProjectsErrors (state, payload) {
      state.errors = payload
    },
    deleteProjectData (state, payload) {
      const index = state.data.findIndex(i => i.id === payload)
      state.data.splice(index, 1)
    },
    deleteExpenseData (state, payload) {
      const index = state.singleData.expenses.findIndex(i => i.id === payload.id)
      state.singleData.expenses.splice(index, 1)
    },
    deleteCostCodeData (state, payload) {
      const index = state.singleData.cost_codes.findIndex(i => i.id === payload.id)
      state.singleData.cost_codes.splice(index, 1)
    },
  },
  actions: {
    async projectsGetData ({ commit }) {
      try {
        const response = await axios.get(BASE_URL)
        if (response.status === 200) {
          commit('getProjectsAllData', response.data.data)
        }
      } catch (error) {
        commit('setProjectsErrors', error)
      }
    },
    async projectsGetUserData ({ commit }, payload) {
      try {
        const response = await axios.post(`${BASE_URL}/user`, {
          id: payload
        })
        if (response.status === 200) {
          commit('getProjectsAllData', response.data.data)
        }
      } catch (error) {
        commit('setProjectsErrors', error)
      }
    },
    async projectsShowData ({ commit }, payload) {
      try {
        const response = await axios.get(BASE_URL +'/'+ payload)
        if (response.status === 200) {
          commit('getProjectsSingleData', response.data.data)
        }
      } catch (error) {
        commit('setProjectsErrors', error)
      }
    },
    async projectsStore ({ commit }, payload) {
      try {
        const response = await axios.post(BASE_URL, payload)
        if (response.status === 201) {
          return response.data.data
        }
      } catch (error) {
        commit('setProjectsErrors', error.response.data)
      }
    },
    async projectsUpdate ({ commit }, payload) {
      try {
        const response = await axios.put(`${BASE_URL}/${payload.id}`, payload)
        if (response.status === 202) {
          return response.data.data
        }
      } catch (error) {
        commit('setProjectsErrors', error.response.data)
      }
    },
    async projectsDestroy ({ commit }, payload) {
      try {
        const response = await axios.delete(`${BASE_URL}/${payload}`, payload)
        if (response.status === 204) {
          commit('deleteProjectData', payload)
        }
      } catch (error) {
        commit('setProjectsErrors', error.response.data)
      }
    }
  }
}

// Export the project module
export default projects
